import { EnumMapper } from "@cak-legacy/core-utils";
import { Taal } from "@cak-legacy/klantondersteuning-client";
import { Language } from "@cak-legacy/shared-locales";

export class LanguageMapper extends EnumMapper<Language, Taal> {
  constructor() {
    super([
      {
        source: Language.Nederlands,
        destination: Taal.Nederlands
      },
      {
        source: Language.English,
        destination: Taal.Engels
      }
    ]);
  }
}
